import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type {
  ErrorReturnEvent,
  OrderReturnEvent,
  SaveQrCodeReturnEvent,
  SaveReturnLabelEvent,
  ShowQrCodeReturnEvent,
  StartReturnEvent,
} from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const START_RETURN_EVENT = 'start_return'

export const triggerStartReturnEvent = (event: StartReturnEvent) =>
  triggerEvent(START_RETURN_EVENT, event)

export const onStartReturnEvent = (callback: EventCallback<StartReturnEvent>) =>
  subscribeEvent(START_RETURN_EVENT, callback)

export const removeStartReturnEvent = (token: EventToken<StartReturnEvent>) =>
  unsubscribeEvent(START_RETURN_EVENT, token)

const ERROR_RETURN_EVENT = 'error_return'

export const triggerErrorReturnEvent = (event: ErrorReturnEvent) =>
  triggerEvent(ERROR_RETURN_EVENT, event)

export const onErrorReturnEvent = (callback: EventCallback<ErrorReturnEvent>) =>
  subscribeEvent(ERROR_RETURN_EVENT, callback)

export const removeErrorReturnEvent = (token: EventToken<ErrorReturnEvent>) =>
  unsubscribeEvent(ERROR_RETURN_EVENT, token)

const ORDER_RETURN_EVENT = 'order_return'

export const triggerOrderReturnEvent = (event: OrderReturnEvent) =>
  triggerEvent(ORDER_RETURN_EVENT, event)

export const onOrderReturnEvent = (callback: EventCallback<OrderReturnEvent>) =>
  subscribeEvent(ORDER_RETURN_EVENT, callback)

export const removeOrderReturnEvent = (token: EventToken<OrderReturnEvent>) =>
  unsubscribeEvent(ORDER_RETURN_EVENT, token)

const SHOW_QR_CODE_RETURN_EVENT = 'show_qr_code_return'

export const triggerShowQrCodeReturnEvent = (event: ShowQrCodeReturnEvent) =>
  triggerEvent(SHOW_QR_CODE_RETURN_EVENT, event)

export const onShowQrCodeReturnEvent = (
  callback: EventCallback<ShowQrCodeReturnEvent>
) => subscribeEvent(SHOW_QR_CODE_RETURN_EVENT, callback)

export const removeShowQrCodeReturnEvent = (
  token: EventToken<ShowQrCodeReturnEvent>
) => unsubscribeEvent(SHOW_QR_CODE_RETURN_EVENT, token)

const SAVE_QR_CODE_RETURN_EVENT = 'save_qr_code_return'

export const triggerSaveQrCodeReturnEvent = (event: SaveQrCodeReturnEvent) =>
  triggerEvent(SAVE_QR_CODE_RETURN_EVENT, event)

export const onSaveQrCodeReturnEvent = (
  callback: EventCallback<SaveQrCodeReturnEvent>
) => subscribeEvent(SAVE_QR_CODE_RETURN_EVENT, callback)

export const removeSaveQrCodeReturnEvent = (
  token: EventToken<SaveQrCodeReturnEvent>
) => unsubscribeEvent(SAVE_QR_CODE_RETURN_EVENT, token)

const SAVE_RETURN_LABEL_EVENT = 'save_return_label'

export const triggerSaveReturnLabelEvent = (event: SaveReturnLabelEvent) =>
  triggerEvent(SAVE_RETURN_LABEL_EVENT, event)

export const onSaveReturnLabelEvent = (
  callback: EventCallback<SaveReturnLabelEvent>
) => subscribeEvent(SAVE_RETURN_LABEL_EVENT, callback)

export const removeSaveReturnLabelEvent = (
  token: EventToken<SaveReturnLabelEvent>
) => unsubscribeEvent(SAVE_RETURN_LABEL_EVENT, token)
